/* Soft Muse — product.js */
(function () {
  'use strict';

  /* ── Helpers ─────────────────────────── */
  function qs(el, sel) { return el ? el.querySelector(sel) : null; }
  function qsa(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : []; }
  function toInt(v, fb) { var n = parseInt(v, 10); return isNaN(n) ? fb : n; }

  function parseJSON(node) {
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { console.warn('[SM] JSON parse error:', e); return null; }
  }

  function formatMoney(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : 'LE {{amount}}';
    var val = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', val).replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* ── COLOR_MAP for swatch painting ──── */
  var COLOR_MAP = {
    white:'#F8F4F0', ivory:'#FFFFF0', cream:'#FFFDD0',
    'off-white':'#F5F0EB', off_white:'#F5F0EB', offwhite:'#F5F0EB',
    blush:'#F2C4CE', pink:'#F2C4CE', rose:'#E8A0B0',
    'blush pink':'#F2C4CE', 'light pink':'#F4C2CE',
    mauve:'#A67C6D', brown:'#8B4513', mocha:'#9E6B58',
    'mauve brown':'#A67C6D', dusty:'#C4A0A5',
    beige:'#D4C4B0', sand:'#C8B99A', camel:'#C19A6B',
    black:'#111111', charcoal:'#3A3A3A',
    gray:'#9A9A9A', grey:'#9A9A9A',
    nude:'#E8C9B0', taupe:'#B09888'
  };

  function resolveColor(name) {
    if (!name) return '#d4c0c0';
    var key = name.toLowerCase().replace(/\s+/g, ' ').trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    for (var k in COLOR_MAP) {
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) return COLOR_MAP[k];
    }
    return '#d4c0c0';
  }

  /* ═══════════════════════════════════════════════════════════
     GLOBAL CART HANDLER — document-level capture
     Runs before any other listener. Checks for a section context
     (_smAddToCart) set by section init; falls back to direct DOM
     read. This is the ONLY place that calls /cart/add.js.
  ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {

    /* Must be a CTA or sticky button (or a child of one) */
    var btn = e.target.closest('[data-add-btn], [data-sticky-btn]');
    if (!btn || btn.disabled) return;

    /* Must live inside a Soft Muse product section */
    var section = btn.closest('[data-sm-product]');
    if (!section) return;

    e.preventDefault();
    e.stopPropagation();

    console.log('[SM] CTA clicked — btn:', btn.getAttribute('data-add-btn') !== null ? 'main' : 'sticky');

    /* ── 1. Use section context if init succeeded ── */
    if (typeof section._smAddToCart === 'function') {
      console.log('[SM] Using section addToCart()');
      section._smAddToCart();
      return;
    }

    /* ── 2. Fallback: build cart items directly from DOM ── */
    console.log('[SM] Section context not found — using DOM fallback');

    /* Variant ID */
    var variantInput = section.querySelector('[data-variant-id]');
    var variantId    = variantInput ? parseInt(variantInput.value, 10) : 0;

    if (!variantId) {
      /* Last resort: first variant from JSON blob */
      var jsonEl = section.querySelector('[data-variants-json]');
      if (jsonEl) {
        try {
          var raw = JSON.parse(jsonEl.textContent);
          if (raw && raw.variants && raw.variants.length) {
            variantId = raw.variants[0].id;
          }
        } catch (_) {}
      }
    }

    if (!variantId) {
      console.error('[SM] Cannot add to cart: no variant ID found in DOM');
      return;
    }

    /* Quantity from active bundle card */
    var activeCard = section.querySelector('[data-bundle-card].is-active') ||
                     section.querySelector('[data-bundle-card][aria-checked="true"]');
    var qty = activeCard ? (parseInt(activeCard.getAttribute('data-bundle-qty'), 10) || 1) : 1;

    console.log('[SM] Fallback add — variantId:', variantId, ' qty:', qty);

    /* Loading state */
    btn.disabled = true;
    var textEl    = btn.querySelector('[data-add-btn-text]') || btn.querySelector('[data-sticky-btn-text]');
    var savedText = textEl ? textEl.textContent : btn.textContent;
    if (textEl) textEl.textContent = 'Adding\u2026';
    else btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (d) {
          throw new Error(d.description || ('HTTP ' + res.status));
        });
      }
      return res.json();
    })
    .then(function () {
      console.log('[SM] Cart add OK \u2192 /cart');
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error('[SM] Cart add failed:', err.message || err);
      btn.disabled = false;
      if (textEl) textEl.textContent = savedText;
      else btn.textContent = savedText;
    });

  }, true /* useCapture — runs before Dawn's bubbling listeners */);

  /* ═══════════════════════════════════════════════════════════
     PER-SECTION INIT — UI state, swatches, bundle, gallery
     Sets section._smAddToCart so the delegation can use the full
     multi-color buildItems() logic.
  ═══════════════════════════════════════════════════════════ */
  qsa(document, '[data-sm-product]').forEach(function (section) {

    var raw = parseJSON(qs(section, '[data-variants-json]'));
    if (!raw) {
      console.warn('[SM] No variants JSON found for section', section.getAttribute('data-section-id'));
      return;
    }

    var variants         = raw.variants || [];
    var colorOptionIndex = toInt(raw.color_option_index, 0);
    var colorValues      = Array.isArray(raw.color_values) ? raw.color_values.slice() : [];
    var selectedOptions  = ((raw.current_options && raw.current_options.length)
                            ? raw.current_options
                            : (variants[0] ? variants[0].options : [])).slice();
    var popupDelay       = toInt(raw.popup_delay, 10);
    var popupCode        = raw.popup_code || 'SM5';

    var activeBundleQty  = 3;
    var bundlePriceText2 = section.getAttribute('data-bundle-price-2') || '';
    var bundlePriceText3 = section.getAttribute('data-bundle-price-3') || '';
    var ctaSuffix1       = section.getAttribute('data-cta-1') || '1 NOW';
    var ctaSuffix2       = section.getAttribute('data-cta-2') || '2 NOW';
    var ctaSuffix3       = section.getAttribute('data-cta-3') || '3 NOW';

    /* DOM refs */
    var priceCurrent        = qs(section, '[data-price-current]');
    var priceCompare        = qs(section, '[data-price-compare]');
    var priceSave           = qs(section, '[data-price-save]');
    var variantIdInput      = qs(section, '[data-variant-id]');
    var qtyInput            = qs(section, '[data-quantity-input]');
    var addBtn              = qs(section, '[data-add-btn]');
    var addBtnText          = qs(section, '[data-add-btn-text]');
    var bundleCards         = qsa(section, '[data-bundle-card]');
    var bundleSelectorsWrap = qs(section, '[data-bundle-selectors]');
    var colorsCount         = qs(section, '[data-colors-count]');
    var colorSelected       = qs(section, '[data-color-selected]');
    var bundlePrice1El      = qs(section, '[data-bundle-price-1]');
    var ctaAnchor           = qs(section, '[data-cta-anchor]');

    var stickyId  = 'StickyBar-' + section.getAttribute('data-section-id');
    var sticky    = document.getElementById(stickyId);
    var stickyBtn = qs(sticky, '[data-sticky-btn]');
    var stickyPrice  = qs(sticky, '[data-sticky-price]');
    var stickyBundle = qs(sticky, '[data-sticky-bundle]');

    var galleryTrack = qs(section, '[data-gallery-track]');
    var slides       = qsa(section, '[data-slide-index]');
    var thumbs       = qsa(section, '[data-gallery-thumb]');
    var counter      = qs(section, '[data-gallery-counter]');

    var popup        = qs(section, '[data-offer-popup]');
    var popupCopyBtn = qs(section, '[data-offer-copy]');
    var popupCloseBtns = qsa(section, '[data-offer-close]');

    console.log('[SM] Section init — id:', section.getAttribute('data-section-id'),
                '| variants:', variants.length,
                '| addBtn:', !!addBtn,
                '| stickyBtn:', !!stickyBtn);

    /* ── Variant helpers ─────────────── */
    function currentVariant() {
      return findVariant(variants, selectedOptions) || variants[0];
    }

    function variantForColor(colorVal) {
      var opts = selectedOptions.slice();
      opts[colorOptionIndex] = colorVal;
      return findVariant(variants, opts) || currentVariant();
    }

    /* ── Gallery ─────────────────────── */
    var currentSlide = 0;

    function updateCounter(idx) {
      if (!counter) return;
      counter.innerHTML = (idx + 1) + '<span class="sm-gallery__counter-sep">/</span>' + slides.length;
    }

    function setActiveThumb(idx) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    function scrollToSlide(idx) {
      if (!galleryTrack || !slides[idx]) return;
      currentSlide = idx;
      galleryTrack.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      updateCounter(idx);
      setActiveThumb(idx);
    }

    if (galleryTrack) {
      var ticking = false;
      galleryTrack.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = galleryTrack.clientWidth;
          if (!w) return;
          var idx = Math.round(galleryTrack.scrollLeft / w);
          if (idx < 0) idx = 0;
          if (idx > slides.length - 1) idx = slides.length - 1;
          if (idx !== currentSlide) {
            currentSlide = idx;
            updateCounter(idx);
            setActiveThumb(idx);
          }
        });
      }, { passive: true });

      /* Mouse drag for desktop */
      var dragging = false, dragStartX = 0, dragScrollLeft = 0;
      galleryTrack.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        dragging = true;
        dragStartX = e.clientX;
        dragScrollLeft = galleryTrack.scrollLeft;
        galleryTrack.setPointerCapture(e.pointerId);
      });
      galleryTrack.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        galleryTrack.scrollLeft = dragScrollLeft - (e.clientX - dragStartX);
      });
      galleryTrack.addEventListener('pointerup', function () { dragging = false; });
      galleryTrack.addEventListener('pointercancel', function () { dragging = false; });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToSlide(toInt(thumb.getAttribute('data-gallery-thumb'), 0));
      });
    });

    updateCounter(0);

    /* ── Variant UI ──────────────────── */
    function updateVariantUI() {
      var v = currentVariant();
      if (!v) return;

      if (variantIdInput) variantIdInput.value = v.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(v.price);
      if (bundlePrice1El) bundlePrice1El.textContent = formatMoney(v.price);

      if (priceCompare) {
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        priceCompare.classList.toggle('is-hidden', !hasCompare);
        priceCompare.textContent = hasCompare ? formatMoney(v.compare_at_price) : '';
      }
      if (priceSave) {
        var hasSave = v.compare_at_price && v.compare_at_price > v.price;
        priceSave.classList.toggle('is-hidden', !hasSave);
      }

      if (addBtn) addBtn.disabled = !v.available;
      if (stickyBtn) stickyBtn.disabled = !v.available;

      if (v.featured_media_id && galleryTrack) {
        var target = qs(section, '[data-media-id="' + v.featured_media_id + '"]');
        if (target) scrollToSlide(toInt(target.getAttribute('data-slide-index'), 0));
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      updateBundleState();
    }

    /* ── Color swatches ──────────────── */
    qsa(section, '[data-option-index]').forEach(function (swatch) {
      var val = swatch.getAttribute('data-option-value');
      if (val && swatch.classList.contains('sm-swatch')) {
        swatch.style.setProperty('--swatch-color', resolveColor(val));
        var dot = qs(swatch, '.sm-swatch__dot');
        if (dot) dot.style.background = resolveColor(val);
      }

      swatch.addEventListener('click', function () {
        var idx = toInt(swatch.getAttribute('data-option-index'), 0);
        var optVal = swatch.getAttribute('data-option-value');
        if (!optVal) return;
        selectedOptions[idx] = optVal;
        qsa(section, '[data-option-index="' + idx + '"]').forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-option-value') === optVal);
          var inp = qs(s.parentElement, '.sm-swatch-input');
          if (inp) inp.checked = s.getAttribute('data-option-value') === optVal;
        });
        if (colorSelected) colorSelected.textContent = '\u2014 ' + optVal;
        updateVariantUI();
      });
    });

    qsa(section, '.sm-swatch-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var idx = toInt(input.getAttribute('data-option-index'), 0);
        var optVal = input.getAttribute('data-option-value') || input.value;
        if (!optVal) return;
        selectedOptions[idx] = optVal;
        qsa(section, '[data-option-index="' + idx + '"]').forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-option-value') === optVal);
        });
        if (colorSelected) colorSelected.textContent = '\u2014 ' + optVal;
        updateVariantUI();
      });
    });

    qsa(section, '.sm-swatch').forEach(function (swatch) {
      var val = swatch.getAttribute('data-option-value');
      if (!val) return;
      var color = resolveColor(val);
      swatch.style.setProperty('--swatch-color', color);
      var dot = qs(swatch, '.sm-swatch__dot');
      if (dot) dot.style.background = color;
    });

    /* ── Bundle helpers ──────────────── */
    function ctaText(qty) {
      if (qty === 1) return 'GET YOUR ' + ctaSuffix1;
      if (qty === 2) return 'GET YOUR ' + ctaSuffix2;
      return 'GET YOUR ' + ctaSuffix3;
    }

    function bundlePriceStr(qty) {
      if (qty === 1) { var v = currentVariant(); return v ? formatMoney(v.price) : ''; }
      if (qty === 2) return bundlePriceText2;
      return bundlePriceText3;
    }

    function updateBundleState() {
      if (qtyInput) qtyInput.value = String(activeBundleQty);
      if (addBtnText) addBtnText.textContent = ctaText(activeBundleQty);
      if (stickyPrice) stickyPrice.textContent = bundlePriceStr(activeBundleQty);
      if (stickyBundle) stickyBundle.textContent = activeBundleQty + (activeBundleQty > 1 ? ' ITEMS' : ' ITEM');
      if (colorsCount) colorsCount.textContent = '(' + activeBundleQty + ')';
      buildBundleSelectors();
    }

    function buildBundleSelectors() {
      if (!bundleSelectorsWrap) return;

      var values = colorValues.slice();
      if (!values.length && variants.length > 0) {
        variants.forEach(function (v) {
          if (v.options && typeof v.options[colorOptionIndex] !== 'undefined') {
            var vv = v.options[colorOptionIndex];
            if (values.indexOf(vv) === -1) values.push(vv);
          }
        });
      }
      if (!values.length) { bundleSelectorsWrap.innerHTML = ''; return; }

      var html = '';
      for (var i = 1; i <= activeBundleQty; i++) {
        var defaultVal = (i === 1 && selectedOptions[colorOptionIndex])
          ? selectedOptions[colorOptionIndex] : values[0];
        var dotColor = resolveColor(defaultVal);
        html += '<div class="sm-bcs__field">';
        html += '<span class="sm-bcs__dot" style="background:' + dotColor + ';"></span>';
        html += '<span class="sm-bcs__label">Dress ' + i + '</span>';
        html += '<select class="sm-bcs__select" data-bundle-color="' + i + '" aria-label="Dress ' + i + ' color">';
        values.forEach(function (val) {
          var sel = (val === defaultVal) ? ' selected' : '';
          html += '<option value="' + String(val).replace(/"/g, '&quot;') + '"' + sel + '>' + val + '</option>';
        });
        html += '</select></div>';
      }
      bundleSelectorsWrap.innerHTML = html;

      qsa(bundleSelectorsWrap, 'select[data-bundle-color]').forEach(function (sel) {
        var dot = sel.parentElement.querySelector('.sm-bcs__dot');
        sel.addEventListener('change', function () {
          if (dot) dot.style.background = resolveColor(sel.value);
          if (sel.getAttribute('data-bundle-color') === '1') {
            selectedOptions[colorOptionIndex] = sel.value;
            qsa(section, '[data-option-index="' + colorOptionIndex + '"]').forEach(function (s) {
              s.classList.toggle('is-active', s.getAttribute('data-option-value') === sel.value);
            });
            if (colorSelected) colorSelected.textContent = '\u2014 ' + sel.value;
            updateVariantUI();
          }
        });
      });
    }

    /* ── Bundle card clicks ──────────── */
    bundleCards.forEach(function (card) {
      card.addEventListener('click', function () {
        activeBundleQty = toInt(card.getAttribute('data-bundle-qty'), 1);
        bundleCards.forEach(function (c) {
          var isActive = c === card;
          c.classList.toggle('is-active', isActive);
          c.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
        updateBundleState();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); card.click(); }
      });
    });

    /* ── Build cart items (multi-color aware) ─ */
    function buildItems() {
      var selectors = qsa(bundleSelectorsWrap, 'select[data-bundle-color]');
      var itemsMap  = {};

      if (selectors.length) {
        selectors.forEach(function (sel) {
          var v = variantForColor(sel.value);
          if (!v || !v.id) return;
          itemsMap[v.id] = (itemsMap[v.id] || 0) + 1;
        });
      }

      /* Fallback: current variant × active qty */
      if (!Object.keys(itemsMap).length) {
        var base = currentVariant();
        if (base && base.id) itemsMap[base.id] = activeBundleQty;
      }

      return Object.keys(itemsMap).map(function (id) {
        return { id: Number(id), quantity: itemsMap[id] };
      });
    }

    /* ── addToCart (called by global delegation) ─ */
    function addToCart() {
      var items = buildItems();

      console.log('[SM] addToCart() — qty:', activeBundleQty, '| items:', JSON.stringify(items));

      if (!items.length) {
        console.error('[SM] buildItems() returned empty array — aborting');
        return;
      }

      /* Loading state */
      if (addBtn)    { addBtn.disabled = true; }
      if (stickyBtn) { stickyBtn.disabled = true; }
      if (addBtnText) addBtnText.textContent = 'Adding\u2026';
      else if (addBtn) addBtn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (d) {
            throw new Error(d.description || ('HTTP ' + res.status));
          });
        }
        return res.json();
      })
      .then(function () {
        console.log('[SM] Cart add success \u2192 /cart');
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[SM] Cart add error:', err.message || err);
        if (addBtn)    { addBtn.disabled = false; }
        if (stickyBtn) { stickyBtn.disabled = false; }
        if (addBtnText) addBtnText.textContent = ctaText(activeBundleQty);
        else if (addBtn) addBtn.textContent = ctaText(activeBundleQty);
      });
    }

    /* ── Expose to global delegation ─────────── */
    section._smAddToCart = addToCart;

    /* ── Sticky bar visibility ────────── */
    function updateSticky() {
      if (!sticky || !ctaAnchor) return;
      var rect = ctaAnchor.getBoundingClientRect();
      var pastCta = rect.bottom < 0;
      var nearBottom = (window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 200;
      var show = pastCta && !nearBottom;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });

    /* ── Popup ────────────────────────── */
    if (popup) {
      popupCloseBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { popup.hidden = true; });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) popup.hidden = true;
      });

      if (popupCopyBtn) {
        popupCopyBtn.addEventListener('click', function () {
          var code = popupCopyBtn.getAttribute('data-code') || popupCode;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(function () {
              popupCopyBtn.textContent = 'COPIED \u2713';
              popupCopyBtn.classList.add('is-copied');
              setTimeout(function () { popup.hidden = true; }, 1400);
            });
          } else {
            try {
              var ta = document.createElement('textarea');
              ta.value = code;
              ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
              document.body.appendChild(ta);
              ta.focus(); ta.select();
              document.execCommand('copy');
              document.body.removeChild(ta);
            } catch (e2) {}
            popupCopyBtn.textContent = 'COPIED \u2713';
            popupCopyBtn.classList.add('is-copied');
            setTimeout(function () { popup.hidden = true; }, 1400);
          }
        });
      }

      if (!sessionStorage.getItem('sm_popup_seen')) {
        setTimeout(function () {
          popup.hidden = false;
          sessionStorage.setItem('sm_popup_seen', '1');
        }, popupDelay * 1000);
      }
    }

    /* ── Init ────────────────────────── */
    updateVariantUI();
    updateBundleState();
    updateSticky();

    console.log('[SM] Section ready. _smAddToCart registered on section element.');

  }); // end forEach section

})();
